import React from 'react';
import { Link } from 'react-router-dom';
import classes from './EmptyRecord.module.scss';
import MainButton from '../buttons/MainButton';
import TextButton from '../buttons/TextButton/TextButton';

export default function EmptyRecord(props) {
  const {
    title,
    icon,
    headerLabel,
    startTracking,
    mainButtonLabel,
    mainButtonHandler,
    textButtonLabel,
    textButtonHandler,
    isApprover
  } = props;

  return (
    <>
      <div className={classes.header}>
        <h1 className={classes.title}>{title}</h1>
      </div>
      <div className={classes.emptyPageContainer}>
        <div className={!isApprover ? classes.container : classes.approvercontainer}>
          <p>{icon}</p>
          <h5>{headerLabel}</h5>
          <h6>{startTracking}</h6>
        </div>
        <div className={!isApprover ? classes.linkcontainer : classes.approverlinkcontainer}>
          <Link to={mainButtonHandler}>
            <MainButton rounded forceWidth="max-content" size="xsmall" variant="primary">
              {mainButtonLabel}
            </MainButton>
          </Link>
          {!isApprover && (
            <Link to={textButtonHandler}>
              <TextButton>{textButtonLabel}</TextButton>
            </Link>
          )}
        </div>
      </div>
    </>
  );
}
